"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCodeFailed = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const sendCodeFailed = exports.sendCodeFailed = (0, _actionGenerator.actionGenerator)(_types.ETwoFactorPhoneActionTypes.SendCodeFailed);